import {
    TICKETLOADING,
    TICKETSUCCESS,
    TICKETERROR,
    TICKETFAILED,
    TICKETRESET
} from "../actionTypes";
import { server_url } from "../axios";

export const ticketsuccess = $=> {
    
    return {
        type: TICKETSUCCESS,
    }
}
export const ticketreset = $ => {
    return {
        type: TICKETRESET
    }
}
export const ticketerror = (err) => {
    return {
        type: TICKETERROR,
        payload: err
    }
}
export const ticketloading = $ => {
    return {
        type: TICKETLOADING
    }
}
export const ticketfailed = payload => {
    return {
        type: TICKETFAILED,
        payload: payload
    }
}





 

export const raiseTicket = payload => async dispatch => {
     dispatch(ticketloading())
    try {
    
         await server_url.post('ticket/raiseticket', {
                ...payload
            })
            .then(res => {
                dispatch(ticketsuccess());
            })
    } catch (e) {
        dispatch(ticketfailed(e.response.data.message))
    };
}


export const findUserTickets = (id, fn) => async dispatch => {
    try {
        await server_url.get(`ticket/${id}`)
            .then(res => {
                fn(res.data.ticket);     
            })
    } catch (e) {
       console.error(e.response.data.message)
    };
}

